export const convertHtmlToPlaintext = (html: string = '') => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(
    html.replace(/(<([^>]+)>)/gi, ''),
    'text/html',
  )
  return doc.body.textContent || ''
}

export const decodeHtmlEntities = (html: string = ''): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html').body?.textContent || ''
  return doc
}
